import { patchState, signalStore, type, withComputed, withHooks, withMethods } from '@ngrx/signals';
import { setAllEntities, withEntities } from '@ngrx/signals/entities';
import { OrganizationFeature } from '@twist/backbone-api-services/ciam';
import { setError, setLoaded, setLoading, withCallState } from '@twist/core';
import { computed, inject } from '@angular/core';
import { FeaturesService } from '../services/features.service';

export const OrganizationFeaturesStore = signalStore(
  { providedIn: 'root' },
  withCallState(),
  withEntities({ entity: type<OrganizationFeature>(), collection: 'features' }),
  withComputed(state => {
    return {
      allFeatures: computed(() => {
        const features = state.featuresEntities();
        return features.sort((a, b) => a.name.localeCompare(b.name));
      })
    };
  }),
  withMethods(state => {
    const featuresService = inject(FeaturesService);
    const initialize = async () => {
      patchState(state, setLoading());
      try {
        const featuresQueryResult = await featuresService.getAllFeatures();
        patchState(state, setLoaded());
        if (featuresQueryResult?.results) {
          patchState(state, setAllEntities(featuresQueryResult?.results, {
            collection: 'features',
            selectId: x => x.key
          }));
        }
      } catch {
        patchState(state, setError('Failed to load features'));
      }
    };
    return {
      initialize
    };
  }),
  withHooks({
    onInit(state) {
      state.initialize();
    }
  })
);
